import { useState } from 'react';
import axios from 'axios';
import TourDetails from "./TourDetails";

export default function TabTour(props) {

  const [chosenTour, setChosenTour] = useState();
  const [tourData, setTourData] = useState();

  const [fade, setFade] = useState(false)


  const triggerFade = () => {
    setFade(prevState => {
      return !prevState
    })
  }

  const chooseTour = (tourId) => {
    //get the tour details
    axios.post(process.env.REACT_APP_CUSTOM_URL + 'getTourplan', { planId: tourId })
      .then(response => {
        //set extra app attributes
        if (response.data.sites !== undefined) {
          Object.entries(response.data.sites).forEach(([siteId, site]) => {
            if (site.machines !== undefined) {
              Object.entries(site.machines).forEach(([machineId, machine]) => {
                machine.autoProposalDone = false;
                response.data.sites[siteId].machines[machineId] = machine;
              });
            }
          });
        }
        setTourData(response.data);
        setChosenTour(tourId);
      });
  }

  const clearTour = () => {
    setChosenTour(null);
    setTourData(null);
  }

  let content;
  if (props.tours.length == 0) {
    content = <div><h3 className="ui inverted block header">Tour <i className={(fade ? 'loading disabled ' : '') + 'circular small icon refresh tour-refresh'} onAnimationEnd={triggerFade} onClick={e => { props.getTourData(); triggerFade(); }}></i></h3><div className="ui yellow message" style={{ marginTop: 2 + 'em' }}><div className="header">Für Sie sind heute keine Touren geplant.</div><p>Bitten wenden Sie sich an Ihren Tourenplaner, um für den heutigen Tag neue Touren zugeordnet zu bekommen</p></div></div>;
  }
  else {
    if (chosenTour == null) {
      const items = props.tours.map(tour => <div className="event" key={tour.id} onClick={() => chooseTour(tour.id)}>
        <div className={(new Date(tour.tstamp).getDate() == new Date().getDate() ? "primary " : "") + "label"} data-text={tour.machines}></div>
        <div className="content">
          <div className="summary">
            <a className="header">Tour {tour.num}</a>
            <div className="date">
              {new Date(tour.tstamp).toLocaleDateString()}
            </div>
          </div>

        </div>
      </div>);
      content = <div><h3 className="ui inverted block header">Tour <i className={(fade ? 'loading disabled ' : '') + 'circular small icon refresh tour-refresh'} onAnimationEnd={triggerFade} onClick={e => { props.getTourData(); triggerFade(); }}></i></h3><div className="ui divided feed">{items}</div></div>;
    }
    else {
      content = <TourDetails tourId={chosenTour} clearTour={clearTour} tourData={tourData} setServiceQueue={props.setServiceQueue} userOptions={props.userOptions} />
    }
  }

  return (
    <div>
      {content}
    </div>
  );
}